import { List, LayoutGrid, CalendarClock } from 'lucide-react'
import clsx from 'clsx'

export type ViewMode = 'list' | 'board' | 'date'

export function ViewToggle({ view, onChange }: { view: ViewMode; onChange: (v: ViewMode) => void }) {
  return (
    <div className="inline-flex rounded-lg border border-gray-200 bg-white p-0.5">
      <button
        onClick={() => onChange('list')}
        className={clsx(
          'flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-medium transition-colors',
          view === 'list' ? 'bg-brand-500 text-white' : 'text-gray-600 hover:text-gray-900'
        )}
      >
        <List className="w-4 h-4" />
        List
      </button>
      <button
        onClick={() => onChange('board')}
        className={clsx(
          'flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-medium transition-colors',
          view === 'board' ? 'bg-brand-500 text-white' : 'text-gray-600 hover:text-gray-900'
        )}
      >
        <LayoutGrid className="w-4 h-4" />
        Board
      </button>
      <button
        onClick={() => onChange('date')}
        className={clsx(
          'flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-medium transition-colors',
          view === 'date' ? 'bg-brand-500 text-white' : 'text-gray-600 hover:text-gray-900'
        )}
      >
        <CalendarClock className="w-4 h-4" />
        Date
      </button>
    </div>
  )
}
